import { apiClient } from '../client';
import type { OwnerType } from '@never2busy/shared';

export interface Favorite {
  id: number;
  userId: number;
  ownerType: OwnerType;
  ownerId: number;
  createdAt: string;
}

export const favoritesApi = {
  async list(ownerType?: OwnerType): Promise<Favorite[]> {
    const { data } = await apiClient.get<Favorite[]>('/favorites', {
      params: ownerType ? { ownerType } : undefined,
    });
    return data;
  },
  async toggle(ownerType: OwnerType, ownerId: number): Promise<{ favorite: boolean }> {
    const { data } = await apiClient.post<{ favorite: boolean }>('/favorites/toggle', {
      ownerType,
      ownerId,
    });
    return data;
  },
};
